import { loadAdapter } from "@tuteria/shared-lib/src/adapter";
import { BUILD_PREFERENCES } from "@tuteria/shared-lib/src/data/tutor-application/sample_data";
import storage from "@tuteria/shared-lib/src/local-storage";
import { IRootStore, RootStore } from "@tuteria/shared-lib/src/stores";
import axios from "axios";

const CURRENT_SKILL = "TUTERIA_SKILL";
const NEW_TUTOR_INFO = "NEW_TUTOR_INFO";
const NEW_TUTOR_TOKEN = "NEW_TUTOR_TOKEN";
const SUBJECT_DESCRIPTION = "SUBJECT_DESCRIPTION";
const TEACHING_STYLE = "TEACHING_STYLE";
const TRACK_RECORD = "TRACK_RECORD";
const TUTERIA_PREFERENCE_KEY = "TUTERIA_PREFERENCES";
const TUTERIA_SUBJECTS_KEY = "TUTERIA_SUBJECTS";
export const FETCHED_TUTOR_KEY = "fetchedTutorData";

const clearSubjectDescription = () => {
  storage.clear(SUBJECT_DESCRIPTION);
  storage.clear(TEACHING_STYLE);
  storage.clear(TRACK_RECORD);
};
async function multipartFetch(url: string, body: FormData) {
  const response = await fetch(url, {
    method: "POST",
    headers: {},
    body,
  });
  return response;
}

const getAdapter = (baseUrl: string, initialData) => {
  const loadExistingTutorInfo = () => {
    return initialData.tutorInfo;
  };
  return {
    loadExistingTutorInfo,
    cloudinaryApiHandler: async (files: any[], progressCallback) => {
      const formData = new FormData();
      files.forEach((file) => formData.append("media", file));
      formData.append("folder", "identity");
      formData.append("kind", "image");
      const { data: response } = await axios.post(baseUrl, formData, {
        onDownloadProgress(progressEvent) {
          const percentCompleted = Math.floor(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          progressCallback(percentCompleted);
        },
      });
      if (Array.isArray(response.data)) {
        response.data.forEach((item) => {
          item.name = item.public_id;
          item.secure_url = item.url;
        });
        return response.data;
      }
      return [
        {
          ...response.data,
          id: response.data.public_id,
          name: response.data.public_id,
          secure_url: response.data.url,
        },
      ];
    },
    async saveSubjectImages(files) {
      const formData = new FormData();
      formData.append("folder", "exhibitions");
      files.forEach(({ file }) => formData.append("media", file));
      const { data: response } = await axios.post(
        "/api/tutors/upload-media",
        formData
      );
      response.data.forEach((item, index) => {
        item.caption = files[index].caption;
      });
      return response.data.map((o) => ({
        id: o.public_id,
        url: o.url,
        caption: o.caption,
      }));
    },
    remoteDeleteImage: async (data) => {
      const response = await postFetcher(baseUrl, {
        path: "/api/tutors/delete-media",
        data: {
          id: data.public_id,
          kind: "image",
        },
      });
      if (response.ok) {
        return await response.json();
      }
      throw "Failed to delete image";
    },

    deleteSubject: async (id) => {
      const response = await postFetcher(baseUrl, {
        data: { id },
        path: "/api/tutors/delete-tutor-subject",
      });
      if (response.ok) {
        const { data } = await response.json();
        return data;
      }
      throw "Failed to delete tutor subjects";
    },
    async deleteBulkSubjects(ids, status) {
      const response = await postFetcher(baseUrl, {
        data: { ids },
        path: "/api/tutors/delete-tutor-subject",
      });
      if (response.ok) {
        const { data } = await response.json();
        return data;
      }
      throw "Failed to delete tutor subjects";
      // let deleteSubject = this.deleteSubject
      // const calls = await Promise.all(ids.map(o=>deleteSubject(o)))
      // return calls
      // console.log(ids, status);
      // return await samplePromise({ ids, status });
    },
    saveSubject(subject_id, subject) {
      storage.set(`${CURRENT_SKILL}_${subject_id}`, subject);
    },

    saveTutorInfo: async ({ data }) => {
      //successfully working
      let toSaveToServer = {};
      Object.keys(data).forEach((x) => {
        let value = data[x] || {};
        let keys = Object.keys(value);
        if (keys.length > 0) {
          toSaveToServer[x] = value;
        }
      });
      const response = await postFetcher(baseUrl, {
        data: toSaveToServer,
        path: "/api/tutors/save-tutor-info",
      });

      if (response.ok) {
        return "";
      }
      throw "Failed to save tutor info";
    },

    getTuteriaSubjects() {
      return storage.get(TUTERIA_SUBJECTS_KEY, []);
    },

    loadExistingSubject(subject_id) {
      const tutorSubjects = storage.get(`${CURRENT_SKILL}_${subject_id}`, {});
      if (Object.keys(tutorSubjects).length > 0) {
        return tutorSubjects;
      }
      throw new Error("Missing editing subject");
    },

    getEarningPercentage() {
      let tutorInfo = loadExistingTutorInfo();
      let others = tutorInfo?.others || {};
      let isPremium = others?.premium;
      return isPremium ? 75 : 70;
    },
    async validatePersonalInfo(formValues) {
      console.log({ formValues });
      const response = await postFetcher(baseUrl, {
        path: "/api/tutors/validate-personal-info",
        data: formValues,
      });
      if (response.ok) {
        const { data } = await response.json();
        if (Object.keys(data).length > 0) {
          throw { formErrors: data };
        }
      }
    },
    saveTutorSubjects: async (subjects) => {
      const response = await postFetcher(baseUrl, {
        path: "/api/tutors/select-subjects",
        data: { subjects },
      });
      if (response.ok) {
        const { data } = await response.json();
        // return data.skills;
        return data.tutorSubjects;
      }
      throw "Failed to save tutor subjects";
    },
    async buildQuizData(subjectInfo) {
      const response = await postFetcher(baseUrl, {
        path: "/api/quiz/generate",
        data: { subjectInfo },
      });
      if (response.ok) {
        const { data } = await response.json();
        let [quizToTake, quizzesList] = data;
        return [quizToTake, quizzesList];
        return data;
      }
      throw "Error building quiz";
    },
    async submitQuizResults(payload) {
      let response = await postFetcher(baseUrl, {
        path: "/api/exam/complete",
        data: payload,
      });
      if (response.ok) {
        return { payload };
      }
      throw "Error grading quiz";
    },

    async updateTutorSubjectInfo(subject, subject_id) {
      const response = await postFetcher(baseUrl, {
        data: { pk: subject_id, ...subject },
        path: "/api/tutors/save-subject-info",
      });
      if (response.ok) {
        const { data } = await response.json();
        // const formattedData = {
        //   id: subject_id,
        //   title: subject.heading,
        //   description: subject.description,
        //   certifications: (subject.certifications || []).map((cert) => ({
        //     name: cert.award_name,
        //     institution: cert.award_institution,
        //   })),
        //   teachingStyle: subject.other_info.teachingStyle,
        //   trackRecords: subject.other_info.trackRecords,
        //   teachingRequirements: subject.other_info.teachingRequirements,
        //   preliminaryQuestions: subject.other_info.preliminaryQuestions,
        //   exhibitions: subject.exhibitions.map((exhibition) => ({
        //     id: exhibition.image,
        //     caption: exhibition.caption,
        //   })),
        // };
        // this.saveSubject(subject_id, formattedData);
        clearSubjectDescription();
        return data;
      }
      throw "Failed to save subject details";
    },
    buildPreferences(subject: { category: string; [key: string]: any }) {
      const placeholder = "$subject_name";
      const preferences = initialData.subjectData.preferences || [];
      const result = preferences
        .filter(({ category }) => category === subject.category)
        .map((preference) => {
          for (let key in preference) {
            const value = preference[key];
            if (typeof value === "string" && value.includes(placeholder)) {
              preference[key] = value.replace(placeholder, subject.name);
            }
            if (
              preference.category === "Test Prep" &&
              key === "name" &&
              ["modules", "test_results"].includes(preference[key])
            ) {
              preference.options = subject.preferenceOptions;
            }
          }
          return preference;
        });
      return result;
    },
    async beginQuiz(payload: { subjects: string[] }, subject_data) {
      const response: any = await postFetcher(baseUrl, {
        path: "/api/quiz/begin",
        data: {
          payload,
          subject_data: { pk: subject_data.skill_id, ...subject_data.payload },
        },
      });
      if (response.ok) {
        const { data } = response.json();
        return data;
      }
      throw "Failed to start test";
    },

    loadSubjectDescription: (name) => {
      return storage.get(name, "");
    },
    saveOnBlur: (name, value) => {
      storage.set(name, value);
    },

    async updateTutorResponse(tutorResponse, slug, tutor_slug, agent) {
      const response = await postFetcher(baseUrl, {
        data: { tutor_slug, slug, tutorResponse, agent },
        path: "/api/home-tutoring/update-tutor-response",
      });
      if (response.status < 400) {
        const data = await response.json();
        return data.data;
      }
      throw "Error saving tutor response";
      // console.log({ payload, requestSlug, tutorSlug, agent });
      // return await samplePromise({});
    },
    async checkSpellingAndGrammar(checks) {
      const response = await postFetcher(baseUrl, {
        data: { checks },
        path: "/api/tutors/spell-check",
      });
      if (response.ok) {
        const { data, hasError } = await response.json();
        if (hasError) {
          throw data;
        }
      }
    },

    async uploadAndVerifyProfile(file) {
      const { slug }: any = loadExistingTutorInfo();
      const formData = new FormData();
      formData.append("media", file);
      formData.append("folder", "profile_pics");
      formData.append("kind", "image");
      formData.append("publicId", `${slug}-profile`);
      formData.append("transform", "true");
      const response = await multipartFetch(baseUrl, formData);

      // const { data: response, statusText } = await axios.post(
      //   baseUrl,
      //   // "/api/tutors/upload-media",
      //   formData
      // );
      if (response.ok) {
        const { data } = await response.json();
        return data;
        // const image = response.data;
        // return {
        //   profile_id: image.public_id,
        //   url: image.url,
        //   quality: image.quality,
        //   has_face: image.has_face,
        // };
      }
      throw "Failed to upload profile pic";
    },
  };
};

export function initializeStore(
  baseUrl,
  initialData
): {
  store: IRootStore;
  adapter: any;
  isLiteTutor?: boolean;
  liteLocation?: any;
} {
  const _adapter: any = getAdapter(baseUrl, initialData);
  console.log("initialData", initialData);
  const adapter = loadAdapter(_adapter);
  let {
    locationInfo = {},
    lite_details,
    isLiteTutor,
  } = initialData.tutorInfo || {};
  return {
    adapter: _adapter,
    isLiteTutor: isLiteTutor,
    liteLocation: lite_details
      ? {
          region: locationInfo.region || lite_details.region,
          state: lite_details.state,
          country: lite_details.country,
          regions: lite_details.regions.concat(lite_details.region),
        }
      : undefined,
    store: RootStore.create(
      {},
      {
        adapter,
        buildPreferences: _adapter.buildPreferences,
      }
    ),
  };
}
async function postFetcher(
  url,
  payload: {
    path: string;
    data: { [key: string]: any };
  }
) {
  const response = await fetch(url, {
    body: JSON.stringify(payload),
    headers: { "content-type": "application/json" },
    method: "POST",
  });
  return response;
}
